import { useEffect } from 'react';
import { gsap } from 'gsap';

export const customizationRoomShowAnimation = ({ index, itemRef, buttonRef, imageRef, titleRef, checkRef }) => {
  useEffect(() => {
    const { current: item } = itemRef;
    const { current: button } = buttonRef;
    const { current: image } = imageRef;
    const { current: title } = titleRef;
    const { current: check } = checkRef;

    const showTimeline = gsap.timeline({ delay: index * 0.1 });

    showTimeline
      .to(item, { scaleX: 0, scaleY: 0, opacity: 1, duration: 0 })
      .to(item, { scaleX: 1, scaleY: 0.05, duration: 0.5 })
      .to(item, { scaleX: 1, scaleY: 1, duration: 0.5 })
      .from(button, { transform: 'translate(0, 100%)', opacity: 0, duration: 0.3 }, '+=.1')
      .from(image, { transform: 'scale(0.3)', opacity: 0, duration: '.5', ease: 'elastic.out(1, 0.5)' })
      .from(title, {
        transform: 'translate(-50%, 0)',
        scale: 0.3,
        opacity: 0,
        duration: 0.5,
        ease: 'elastic.out(1, 0.5)',
        clearProps: 'transform',
      })
      .from(check, { opacity: 0, duration: 0.3 }, '-=.2');

    return () => {
      showTimeline?.kill?.();
    };
  }, [index]);
};
